import { clearVoucherSequenceAlerts } from "@/utils/voucherSequenceAlerts";

const ACCESS_STORAGE_KEY = "access";
const SESSION_EXPIRED_ERROR_CODE = "SESSION_EXPIRED";

const normalizeBase64Url = (value) => {
  const normalized = value.replace(/-/g, "+").replace(/_/g, "/");
  const padding = normalized.length % 4;

  if (padding === 0) {
    return normalized;
  }

  return normalized.padEnd(normalized.length + (4 - padding), "=");
};

export const getStoredAccessData = () => {
  const rawValue = localStorage.getItem(ACCESS_STORAGE_KEY);

  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
};

export const clearStoredSession = () => {
  clearVoucherSequenceAlerts();
  localStorage.removeItem(ACCESS_STORAGE_KEY);
  localStorage.removeItem("modules");
  localStorage.removeItem("boxState");
};

export const getJwtPayload = (token) => {
  if (typeof token !== "string" || token.trim() === "") {
    return null;
  }

  const parts = token.split(".");

  if (parts.length !== 3) {
    return null;
  }

  try {
    return JSON.parse(atob(normalizeBase64Url(parts[1])));
  } catch (error) {
    return null;
  }
};

export const hasValidSession = () => {
  const accessData = getStoredAccessData();
  const token = accessData?.token;
  const payload = getJwtPayload(token);

  if (!payload || typeof payload.exp !== "number") {
    return false;
  }

  return payload.exp > Math.floor(Date.now() / 1000);
};

export const buildSessionExpiredError = () => {
  const error = new Error("SESSION_EXPIRED");

  error.code = SESSION_EXPIRED_ERROR_CODE;
  error.isSessionExpired = true;

  return error;
};

export const isSessionExpiredError = (error) => {
  return (
    error?.isSessionExpired === true ||
    error?.code === SESSION_EXPIRED_ERROR_CODE
  );
};
